/**
 * Reference-counted body scroll lock.
 *
 * With stacked overlays a single shared body class meant closing the top one
 * re-enabled background scroll behind the still-open one underneath, so the
 * class is only dropped once every locker has released it.
 *
 * Every overlay that wants to lock the page must go through here rather than
 * touching `noscroll` directly — a raw `add` leaks the lock when the overlay
 * closes without a follow-up modal, and a raw `remove` unlocks the page behind
 * whatever is still open.
 */
let lockCount = 0

export const lockBodyScroll = () => {
  lockCount += 1
  document.body.classList.add('noscroll')
}

export const unlockBodyScroll = () => {
  lockCount = Math.max(0, lockCount - 1)
  if (lockCount === 0) document.body.classList.remove('noscroll')
}
